import { render, staticRenderFns } from "./CardStreamStartStep.vue?vue&type=template&id=187b2e23&scoped=true&"
import script from "./CardStreamStartStep.vue?vue&type=script&lang=js&"
export * from "./CardStreamStartStep.vue?vue&type=script&lang=js&"
import style0 from "./CardStreamStartStep.vue?vue&type=style&index=0&id=187b2e23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b2e23",
  null
  
)

export default component.exports